import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { CandidateOutreachPageComponent } from './candidate-outreach-page.component';
import { FormsModule } from '@angular/forms';
import { JobProfileModule } from '../job-profile-page/job-profile/job-profile.module';
import { TabsModule, TooltipModule } from 'ngx-bootstrap';
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { AddEditCandidateContactOneModule } from 'src/app/shared/add-edit-candidate-contact-one/add-edit-candidate-contact-one.module';
import { CandidateAdditionalDetailsModule } from 'src/app/shared/candidate-additional-details/candidate-additional-details.module';
import { FeedbackExecutionComponentModule } from 'src/app/shared/feedback-execution/feedback-execution-component.module';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { CandidateCardIconsModule } from 'src/app/shared/candidate-card-icons/candidate-card-icons.module';

const states: Ng2StateDeclaration[] = [
  {
    name: 'candidateOutreach',
    url: '/candidateOutreach',
    component: CandidateOutreachPageComponent,
    data: {
      requireLogin: true
    },
    params: {
      outreachId: null,
      candidateId: null,
      companyId: null,
      tokenId: null
    }
  }
];

@NgModule({
  declarations: [CandidateOutreachPageComponent],
  imports: [
    CommonModule,
    FormsModule,
    JobProfileModule,
    TabsModule.forRoot(),
    AddEditCandidateContactOneModule,
    CandidateAdditionalDetailsModule,
    FeedbackExecutionComponentModule,
    PipesModule,
    CandidateCardIconsModule,
    TooltipModule.forRoot(),
    DropzoneModule,
    UIRouterModule.forChild({ states })
  ],
  exports: [CandidateOutreachPageComponent],
  entryComponents: [CandidateOutreachPageComponent]
})
export class CandidateOutreachPageModule { }
